// extracted by mini-css-extract-plugin
module.exports = {"annual-conference":"AnnualConference_annual-conference__opsR0"};